import React, { useEffect, useState } from "react";
import withdrawalImg from "../../../assets/images/finance/withdrawal.png";
import StringInput from "../../Inputs/StringInput";
import UploadInput from "../../Inputs/UploadInput";
import { AutoComplete } from "antd";

import "./WithdrawalWidget.css";
import { isAdminUser } from "../../../services/authService";
import { getAllUsersEmail } from "../../../services/fhpService";
import { Loader } from "../../Loader/Loader";

const WithdrawalWidget = ({
  pdfPath,
  setPdfPath,
  setWithdrawalSum,
  withdrawalSum,
  setInvoiceStrBase64,
  clickAddFinance,
  setWithdrawalEmail,
  withdrawalEmail,
  loading,
  openTable,
}) => {
  const isAdmin = isAdminUser();
  const [allUsersEmails, setAllUsersEmails] = useState([]);
  const [tempWithdrawalEmail, setTempWithdrawalEmail] = useState("");
  const loadUsersEmails = async () => {
    const response = await getAllUsersEmail();
    console.log("Response from getAllUsersEmail:", response); // Debug log

    // Filter out users without email and remove duplicates
    const validUsers =
      response?.filter(({ email }) => email && email.trim() !== "") || [];
    const uniqueUsers = validUsers.filter(
      (user, index, self) =>
        index === self.findIndex((u) => u.email === user.email)
    );

    const emailsOptions = uniqueUsers.map(
      ({ email, firstname, lastname }, index) => ({
        label: `${firstname} ${lastname} - (${email})`,
        value: email,
        key: `${email}-${index}`, // Ensure unique key even for edge cases
      })
    );

    console.log("Formatted emailsOptions:", emailsOptions); // Debug log
    setAllUsersEmails(emailsOptions);
  };
  useEffect(() => {
    if (isAdmin) {
      loadUsersEmails();
    }
  }, [isAdmin]);

  useEffect(() => {
    console.log("allUsersEmails updated:", allUsersEmails);
  }, [allUsersEmails]);

  return (
    <div className="withdrawal-widget">
      <div className="withdrawal-header">
        <img
          src={withdrawalImg}
          alt="Withdrawal logo"
          className="withdrawal-logo"
        />
        משיכת כספים
      </div>
      <div className="withdrawal-body">
        {" "}
        {isAdmin && (
          <div className="email-select">
            מייל{" "}
            <AutoComplete
              options={allUsersEmails}
              value={
                tempWithdrawalEmail
                  ? allUsersEmails.find(
                      (option) => option.value === tempWithdrawalEmail
                    )?.label || tempWithdrawalEmail
                  : ""
              }
              placeholder="בחר מייל..."
              onChange={(value) => {
                console.log("AutoComplete onChange:", value);
                // If it's a label (contains " - "), extract the email
                if (value && value.includes(" - (") && value.endsWith(")")) {
                  const emailMatch = value.match(/\(([^)]+)\)$/);
                  if (emailMatch) {
                    setTempWithdrawalEmail(emailMatch[1]);
                  }
                } else {
                  // If it's just typing, keep the typed value
                  setTempWithdrawalEmail(value);
                }
              }}
              onSelect={(value, option) => {
                console.log("AutoComplete onSelect:", value, option);
                // Extract email from the selected option
                if (option && option.value) {
                  setWithdrawalEmail(option.value);
                  setTempWithdrawalEmail(option.value);
                } else if (
                  value &&
                  value.includes(" - (") &&
                  value.endsWith(")")
                ) {
                  const emailMatch = value.match(/\(([^)]+)\)$/);
                  if (emailMatch) {
                    setWithdrawalEmail(emailMatch[1]);
                    setTempWithdrawalEmail(emailMatch[1]);
                  }
                } else {
                  setWithdrawalEmail(value);
                  setTempWithdrawalEmail(value);
                }
              }}
              style={{
                width: "200px",
              }}
              filterOption={(inputValue, option) =>
                option?.label?.toLowerCase().includes(inputValue.toLowerCase())
              }
              allowClear
              showSearch
            />
          </div>
        )}
        <div className="click" style={{ cursor: "pointer", width: "200px" }}>
          <StringInput
            title="סכום למשיכה"
            value={withdrawalSum}
            disabled={!isAdmin}
            onValueChange={(value) => setWithdrawalSum(value)}
          />
        </div>
        <UploadInput
          pdfPath={pdfPath}
          setPdfPath={setPdfPath}
          title="העלאת חשבונית"
          setFileStrBase64={setInvoiceStrBase64}
        />
        {loading ? (
          <div className="send-withrawal-loader">
            <Loader size="small" loaderText="בקשה פיננסית נשלחת..." />
          </div>
        ) : (
          <button className="send-withrawal-btn" onClick={clickAddFinance}>
            שלח בקשה
          </button>
        )}
      </div>
      <div className="withdrawal-footer">
        ההעברות מתבצעות בכל 20 לחודש עבור כל החשבוניות שהוגשו עד ה- 15 לחודש
      </div>
      <div className="withdrawal-footer">
        פניות להנהלה:{" "}
        <a href="mailto:accounts@hotelsriver.com">accounts@hotelsriver.com</a>
      </div>
    </div>
  );
};

export default WithdrawalWidget;
